module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_7-7f8678d62e0b2c6383f9fb80ea3993fa.png";